module.exports = __webpack_public_path__ + "static/gato-8ef8ae4f950394028153037d3da73053.jpeg";